import request from './request'

/**
 * 获取退款列表
 * @param {Object} params - 查询参数
 * @param {number} params.page - 页码
 * @param {number} params.page_size - 每页条数
 * @param {number} params.refund_status - 退款状态（可选）1=待审批，2=处理中，3=已完成，4=失败
 * @returns {Promise} - 返回退款列表数据
 */
export function getRefundList(params) {
  
  return request({
    url: '/fuyou/iccid/recharge/admin/refund/list',
    method: 'post',
    data: {
      page: params.page || 1,
      page_size: params.page_size || 20,
      refund_status: params.refund_status
    }
  })
}

/**
 * 创建退款申请
 * @param {Object} data - 退款申请数据
 * @param {string} data.order_no - 订单号（必填）
 * @param {number} data.refund_amount - 退款金额（必填）
 * @param {string} data.refund_reason - 退款原因（必填）
 * @returns {Promise} - 返回创建结果
 */
export function createRefund(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/refund/create',
    method: 'post',
    data: {
      order_no: data.order_no,
      refund_amount: data.refund_amount,
      refund_reason: data.refund_reason
    }
  })
}

/**
 * 审批退款申请
 * @param {Object} data - 审批数据
 * @param {string} data.refund_no - 退款单号（必填）
 * @param {number} data.approve_result - 审批结果（必填）1=通过，2=拒绝
 * @param {string} data.approve_remark - 审批备注（可选）
 * @returns {Promise} - 返回审批结果
 */
export function approveRefund(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/refund/approve',
    method: 'post',
    data: {
      refund_no: data.refund_no,
      approve_result: data.approve_result,
      approve_remark: data.approve_remark || ''
    }
  })
}

/**
 * 获取退款详情
 * @param {string} refundNo - 退款单号
 * @returns {Promise} - 返回退款详情数据
 */
export function getRefundDetail(refundNo) {
  return request({
    url: '/fuyou/iccid/recharge/admin/refund/detail',
    method: 'post',
    data: {
      refund_no: refundNo
    }
  })
}
